export function narrowTypeByField<T>(value: unknown, field: string): value is T {
  return typeof value === "object" && value !== null && field in value;
}

export function toNarrowedTypeOrNull<T>(value: unknown, field: string): T | null {
  if (narrowTypeByField(value, field)) return value as T;

  return null;
}
